// The version of each legal document the signup screen shows (DPDP G4,
// 2026-10-29). Sent with the signup so the server records exactly what was
// shown, and refuses (409 POLICY_CHANGED) when this page is older than the
// documents. A copy, not an import of src/legal/*: those documents are large
// and this file sits on the signup path. `check:docs` fails the build unless
// these equal BOTH the documents' `lastUpdated` and server/legal-versions.mjs.
// Vendored byte-identical to mobile/src/core/legalVersions.ts.
export const LEGAL_VERSIONS = {
  privacy: '2026-10-30',
  terms: '2026-10-30',
} as const;
